export const customerReviewsTokens = {
  colors: {
    background: "#f8fafc",
    surface: "#ffffff",
    text: "#07142f",
    textSoft: "#26334d",
    textMuted: "#5d6779",
    accent: "#ed1c24",
    accentDark: "#c80f17",
    accentSoft: "rgba(237, 28, 36, 0.1)",
    accentSofter: "rgba(237, 28, 36, 0.07)",
    border: "rgba(7, 20, 47, 0.08)",
    divider: "rgba(7, 20, 47, 0.14)",
    dot: "rgba(7, 20, 47, 0.18)",
    arrow: "#07142f",
    shadow: "0 18px 46px rgba(7, 20, 47, 0.1)",
    arrowShadow: "0 12px 30px rgba(7, 20, 47, 0.13)",
  },
  avatarTones: {
    rose: {
      background: "rgba(237, 28, 36, 0.1)",
      text: "#ed1c24",
    },
    indigo: {
      background: "rgba(65, 76, 224, 0.1)",
      text: "#3441d9",
    },
    slate: {
      background: "rgba(7, 20, 47, 0.08)",
      text: "#07142f",
    },
    gold: {
      background: "rgba(245, 158, 11, 0.14)",
      text: "#b45309",
    },
  },
  icons: {
    badge: "message",
    star: "star",
    quote: "quote",
    trust: "shield",
    previous: "chevronLeft",
    next: "chevronRight",
    reviewsLink: "externalLink",
  },
  radius: {
    card: 8,
    pill: 999,
    control: 999,
  },
  sizes: {
    maxWidth: 1280,
    avatar: 72,
    tabletAvatar: 52,
    mobileAvatar: 56,
    control: 58,
    mobileControl: 42,
  },
  spacing: {
    shellY: 56,
    shellX: 24,
    tabletShellY: 46,
    tabletShellX: 22,
    mobileShellY: 36,
    mobileShellX: 16,
    cardGap: 32,
    tabletCardGap: 16,
    mobileCardGap: 20,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    badge: {
      fontSize: 15,
      mobileFontSize: 13,
      lineHeight: 1,
      fontWeight: 850,
      letterSpacing: 0,
    },
    title: {
      fontSize: 56,
      tabletFontSize: 42,
      mobileFontSize: 34,
      lineHeight: 1.05,
      mobileLineHeight: 1.12,
      fontWeight: 900,
      letterSpacing: 0,
    },
    summary: {
      fontSize: 20,
      tabletFontSize: 17,
      mobileFontSize: 15,
      lineHeight: 1.15,
      fontWeight: 500,
      letterSpacing: 0,
    },
    score: {
      fontSize: 21,
      tabletFontSize: 18,
      mobileFontSize: 15,
      lineHeight: 1,
      fontWeight: 900,
      letterSpacing: 0,
    },
    name: {
      fontSize: 18,
      tabletFontSize: 13,
      mobileFontSize: 14,
      lineHeight: 1.16,
      fontWeight: 850,
      letterSpacing: 0,
    },
    meta: {
      fontSize: 14,
      tabletFontSize: 11,
      mobileFontSize: 12,
      lineHeight: 1.2,
      fontWeight: 500,
      letterSpacing: 0,
    },
    body: {
      fontSize: 18,
      tabletFontSize: 13,
      mobileFontSize: 14,
      lineHeight: 1.72,
      fontWeight: 500,
      letterSpacing: 0,
    },
    trust: {
      fontSize: 16,
      mobileFontSize: 14,
      lineHeight: 1.45,
      fontWeight: 500,
      letterSpacing: 0,
    },
  },
  defaults: {
    badgeText: "Trusted by Our Customers",
    title: "What Our Customers Say",
    rating: "4.9/5",
    ratingLabel: "4.9 out of 5 stars",
    reviewsLinkLabel: "from 120+ reviews",
    reviewsHref: "/reviews",
    footerText: "Real reviews from real customers who love our services.",
    dotCount: 5,
    activeDotIndex: 2,
    initialReviewIndex: 0,
    reviews: [
      {
        id: "christopher-mata",
        name: "Christopher Mata",
        dateText: "4 months ago",
        rating: 5,
        text: "Amazing experience from start to finish. Ben was incredibly responsive, solved the problem quickly, and answered all my questions along the way.",
        avatar: {
          initials: "C",
          tone: "rose",
        },
      },
      {
        id: "jasleen-kaur",
        name: "Jasleen Kaur",
        dateText: "6 months ago",
        rating: 5,
        text: "I reached out after reading the reviews and Alan exceeded my expectations. He responded promptly, communicated clearly, and delivered excellent results.",
        avatar: {
          initials: "J",
          tone: "indigo",
        },
      },
      {
        id: "anhelina-navitskaya",
        name: "Anhelina Navitskaya",
        dateText: "6 months ago",
        rating: 5,
        text: "Ben was a pleasure to work with - professional, friendly, and highly skilled. Communication was seamless and the quality of work was fantastic.",
        avatar: {
          initials: "A",
          tone: "slate",
        },
      },
    ],
  },
} as const;

export type CustomerReviewsAvatarTone =
  keyof typeof customerReviewsTokens.avatarTones;

export type CustomerReviewsIconSlot =
  keyof typeof customerReviewsTokens.icons;

export type CustomerReviewsIconToken =
  (typeof customerReviewsTokens.icons)[CustomerReviewsIconSlot];

export type CustomerReviewsColorToken =
  keyof typeof customerReviewsTokens.colors;
